export default {"src":"/_next/static/media/shortCurlyWave.9dbd5167.svg","height":548,"width":1133};